import React from 'react';
import './BenefitHeading.css';
const BenefitHeading = () => {
  return <div className="benefit-title-text">Benefits</div>;
};

export default BenefitHeading;
